import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=d802dbb8&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=d802dbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d802dbb8",
  null
  
)

/* custom blocks */
import block0 from "./password.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1999871914%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fpassword-reset%2FPasswordReset.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./password.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1999871914%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fpassword-reset%2FPasswordReset.vue&external"
if (typeof block1 === 'function') block1(component)
import block2 from "../user.fr.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1999871914%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fpassword-reset%2FPasswordReset.vue&external"
if (typeof block2 === 'function') block2(component)
import block3 from "../user.en.json?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1999871914%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fpassword-reset%2FPasswordReset.vue&external"
if (typeof block3 === 'function') block3(component)

export default component.exports